import { Component, OnDestroy, OnInit, HostListener, Renderer2, ElementRef, ViewChild } from '@angular/core';
import { finalize, Subscription } from 'rxjs';
import { GlobalService } from '../../services/global.service';
import { AuthService } from 'src/app/auth/services/auth.service';
import { Router } from '@angular/router';
import { UserIdleService } from 'angular-user-idle';
import { MessageHandler } from 'src/app/shared/handlers/message-handler';
import { StorageHandler } from 'src/app/shared/handlers/storage-handler';
import { MatDialog } from '@angular/material/dialog';
import { ScenarioListDialogComponent } from '../scenario/scenario-list-dialog/scenario-list-dialog.component';
import { MondelezDataService } from 'src/app/shared/services/mondelez-data.service';
import { Scenario } from '../../models/scenario';
import { MondelezService } from 'src/app/shared/services/mondelez.service';
import { StepsSummaryComponent } from 'src/app/features/simulation/components/steps-summary/steps-summary.component';
import { ChatComponent } from 'src/app/core/components/chat/chat.component';
import { environment } from 'src/environments/environment';
import { User } from '../../models/user';
import { NavParam } from 'src/app/shared/interfaces/global-filter-model';
import { ChatDataService } from '../../services/chat-data.service';
import { ExcelExportHandler } from 'src/app/shared/handlers/export-excel-handler';
import { ChatService } from '../../services/chat.service';
import { IdleService } from 'src/app/core/services/idle.service';
import { AlertHandler } from '../../handlers/alert-handler';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
})
export class MainComponent implements OnInit, OnDestroy {
  // use global params to set these timers.
  private subscriptions = new Subscription();
  public selectedScenario: Scenario;
  public maxIterationCode: number;
  showTimeFrameModeToggle = false;
  public navList: NavParam[] = [];

  public dialogRef: any;

  messages = [];
  isTyping: boolean = false;
  showDownloadLoader = false;
  downloadFileOptions = [];

  @ViewChild('chatIcon') chatIcon: ElementRef;
  isDragging = false;
  wasDragged = false;
  chatIconPosition = { top: 0, left: 0 };
  dragOffset = { x: 0, y: 0 };

  // private allowedDomains = ['ey.com', 'in.ey.com'];
  private allowedDomain = 'ey.com';
  private allowedEmails = environment.allowedUserForChatbot;
  showChatbot = false;
  user: User;
  globalFilterVisible = false;
  visibleMDMModule = false;
  navBarVisible = true;
  visibleDataDownload = false;

  constructor(
    private globalService: GlobalService,
    private authService: AuthService,
    private router: Router,
    public dialog: MatDialog,
    private mondelezService: MondelezService,
    public mondelezDataService: MondelezDataService,
    private renderer: Renderer2,
    private chatDataService: ChatDataService,
    private chatService: ChatService,
    private idleService: IdleService
  ) {}

  ngOnInit(): void {
    // user inactivity
    this.idleService.startWatching();

    this.subscriptions.add(
      this.idleService.onAutoLogout$.subscribe((value) => {
        this.idleService.stopWatching();
        this.onLogout(value);
      })
    );

    this.user = this.globalService.user;

    // Logic: Hiding Chatbot for non EY user
    this.showChatbot = this.isChatbotAccessible();
    this.visibleDataDownload = this.user.user_screens.filter((el) => el.supply_mode == 'mdm' && el.is_active).length > 1 ? true : false;
    if (this.user.user_screens.findIndex((el) => el.supply_mode == 'mdm' && el.is_active) > -1) {
      this.visibleMDMModule = true;
    } else {
      this.visibleMDMModule = false;
    }
    const tempNavList = this.user.user_screens.filter((el) => el.page_navigator);

    tempNavList.reduce((acc, item) => {
      if (!acc.map((el) => el.screen_name).includes(item.screen_name)) {
        acc.push({ ...item, is_active: item.is_active });
      }
      return acc;
    }, this.navList);

    this.mondelezService.getScenarioData().subscribe((res) => {
      if (res['response'] === 'SUCCESS') {
        this.maxIterationCode = res['max_iteration_code'];
        if (StorageHandler.getLocalStorage('current_scenario')) {
          this.selectedScenario = JSON.parse(StorageHandler.getLocalStorage('current_scenario'));
        } else {
          this.selectedScenario = res['scenario'][res['scenario'].length - 1];
        }
        // let payload = {
        //   iteration_code: this.selectedScenario.iteration_code,
        //   scenario_id: this.selectedScenario.scenario_id,
        // };
        // let updateFilterMaster = true;
        if (this.router.url.includes('logger-view')) {
          this.globalFilterVisible = false;
          this.navBarVisible = false;
        } else {
          this.globalFilterVisible = true;
        }

        // this.mondelezService.fetchFilterData(payload, updateFilterMaster).subscribe({
        //   next: (res) => {
        //     if (res['response'] === 'SUCCESS' && res['filters'].length > 0) {
        //       this.globalFilterVisible = true;
        //     }
        //   },
        //   error: (err) => alert(MessageHandler.INTERNAL_ERROR),
        // });
        this.mondelezDataService.updateCurrentScenario(this.selectedScenario);
      }
    });
    this.initializeDownloadOption();
  }

  initializeDownloadOption() {
    this.downloadFileOptions = [
      { label: 'Bottleneck Output', fileName: 'agg_manufacturing_output', checked: false },
      { label: 'Format Output', fileName: 'agg_manufacturing_format_output', checked: false },
    ];
  }

  ngOnDestroy(): void {
    this.idleService.stopWatching();
    this.subscriptions.unsubscribe();
  }

  isChatbotAccessible() {
    const userEmailDomain = this.user.email?.split('@')[1];
    let allowedDOmain = userEmailDomain.toLowerCase().endsWith(this.allowedDomain);
    let allowedUser = this.allowedEmails.includes(this.user.email.toLowerCase());
    return allowedDOmain || allowedUser;
  }

  onOpenDialog() {
    this.dialogRef = this.dialog.open(StepsSummaryComponent, {
      width: '90vw',
      height: '90vh',
      disableClose: false,
    });
  }

  onDownloadData(fileName: string, opRef) {
    // const fileList = this.downloadFileOptions.filter((el) => el.checked).map((el) => el.fileName);
    if (!this.visibleDataDownload) {
      return;
    }
    const fileList = [fileName];
    if (fileList.length == 0) {
      return;
    }
    this.showDownloadLoader = true;
    const payload = {
      table_list: fileList,
      iteration_code: this.selectedScenario.iteration_code,
      scenario_id: this.selectedScenario.scenario_id,
    };
    this.mondelezService.downloadMasterData(payload).subscribe({
      next: (result: any) => {
        fileList.forEach(async (tableName) => {
          let columns = result.data[tableName + '_header'].map((el) => ({
            field: el.toString(),
            label: el.toString(),
          }));
          ExcelExportHandler.exportFlatTableToExcelWithoutFormatting(result['data'][tableName], columns, tableName, tableName, this.selectedScenario.scenario_name);
        });
        opRef.hide();
        this.showDownloadLoader = false;
        this.initializeDownloadOption();
      },
      error: (err) => {
        this.showDownloadLoader = false;
        AlertHandler.ErrorAlert(err.error.message);
      },
    });
  }

  startDrag(event: MouseEvent) {
    this.isDragging = true;
    const rect = this.chatIcon.nativeElement.getBoundingClientRect();

    // Include the scroll offsets
    this.dragOffset = {
      x: event.clientX - rect.left,
      y: event.clientY - rect.top,
    };

    event.preventDefault();
  }

  @HostListener('document:mousemove', ['$event'])
  drag(event: MouseEvent) {
    if (this.isDragging) {
      const viewportWidth = window.innerWidth;
      const viewportHeight = window.innerHeight;
      const iconWidth = this.chatIcon.nativeElement.offsetWidth;
      const iconHeight = this.chatIcon.nativeElement.offsetHeight;

      // Get the scroll offsets
      const scrollX = window.scrollX || 0;
      const scrollY = window.scrollY || 0;

      // Calculate new top and left positions considering scroll
      let top = event.clientY - this.dragOffset.y + scrollY;
      let left = event.clientX - this.dragOffset.x + scrollX;

      // Restrict within the viewport boundaries (including scroll)
      if (left < scrollX) left = scrollX; // Left boundary
      if (left + iconWidth > viewportWidth + scrollX) left = viewportWidth + scrollX - iconWidth; // Right boundary
      if (top < scrollY) top = scrollY; // Top boundary
      if (top + iconHeight > viewportHeight + scrollY) top = viewportHeight + scrollY - iconHeight; // Bottom boundary

      this.chatIconPosition = { top, left };
      this.renderer.setStyle(this.chatIcon.nativeElement, 'top', `${top}px`);
      this.renderer.setStyle(this.chatIcon.nativeElement, 'left', `${left}px`);
      this.wasDragged = true;
    }
  }

  @HostListener('document:mouseup', ['$event'])
  endDrag(event: MouseEvent) {
    this.isDragging = false;
    setTimeout(() => {
      this.wasDragged = false;
    }, 10); // Short delay to differentiate drag from click
  }

  openChatbot(event: MouseEvent, isMinimized) {
    event.stopPropagation();
    if (!this.openChatbot) {
      return;
    }
    if (this.wasDragged) {
      return; // Ignore click event immediately after a drag
    }

    if (this.dialogRef) {
      this.dialogRef.close();
      this.dialogRef = null;
    } else {
      let chatStatus = this.chatDataService.getChatStatus();
      this.dialogRef = this.dialog.open(ChatComponent, {
        width: '18vw',
        height: '70vh',
        panelClass: 'chatbot-dialog',
        data: {
          messages: chatStatus?.messages,
          isTyping: chatStatus?.isTyping,
          isMinimized: isMinimized,
        },
        position: {
          right: '3rem',
          bottom: '5rem',
        },
        disableClose: false,
      });
    }

    this.dialogRef?.afterClosed().subscribe((result) => {
      console.log('Chatbot dialog was closed');
      this.dialogRef.close();
      this.dialogRef = null;
    });
  }

  public onLogout(value = null) {
    this.authService
      .logout({})
      .pipe(finalize(() => this.handleLogout(value)))
      .subscribe();
  }

  private handleLogout(value) {
    if (environment.msalEnabled) {
      this.globalService.deleteUserSession();
      if (value === 'REDIRECT_LOGIN') {
        this.globalService.redirectMsalLogin();
      } else {
        this.router.navigate(['auth/msal-logout']);
      }
    } else {
      this.router.navigate(['auth/logout']);
      this.globalService.deleteUserSession();
    }
    this.chatDataService.setChatStatus({ messages: [], isTyping: false });
    this.chatService.resetSocketOnLogout();
  }

  public onOpenScenario(mode?: string) {
    this.dialogRef = this.dialog.open(ScenarioListDialogComponent, {
      width: '50vw',
      minWidth: '500px',
      height: '53vh',
      disableClose: true,
      data: { selectedScenario: this.selectedScenario, maxIterationCode: this.maxIterationCode },
    });

    this.dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.mondelezDataService.updateCurrentScenario(result);
        this.selectedScenario = result;
        // let payload = {
        //   iteration_code: this.selectedScenario.iteration_code,
        // };
        // let updateFilterMaster = true;

        // this.mondelezService.fetchFilterData(payload, updateFilterMaster).subscribe({ error: (err) => alert(MessageHandler.INTERNAL_ERROR) });
        // // console.log('scenario dialog closed', this.selectedScenario);
      }
    });
  }

  public navigatePath() {
    StorageHandler.removeLocalStorage('current_master_plan');
    this.router.navigate(['/mdm']);
  }
}
